/**
 * Customer-state UI components.
 *
 * After the demo-data removal, only one banner remains: the amber banner shown
 * to brand-new customers who have signed up but haven't connected their first
 * integration yet. It nudges them to connect Tally / Zoho. No demo / visitor /
 * "Explore demo" plumbing — those concepts are gone from the app.
 */
import React from "react";
import { Clock } from "lucide-react";

/**
 * Amber banner for the "new customer" state — they've signed up but haven't
 * connected anything yet. Prompts them to connect their first integration.
 */
export function NewCustomerBanner({ customer }) {
  return (
    <div
      data-testid="new-customer-banner"
      style={{
        background: "#FEF3C7",
        borderBottom: "1px solid #FCD34D",
        padding: "12px 24px",
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
      }}
    >
      <Clock size={14} style={{ color: "#92400E" }} />
      <span style={{ color: "#92400E", fontSize: 13 }}>
        Connect your first integration to see your dashboard.
        {customer?.phone ? (
          <>
            {" "}Our team will call you at <strong>{customer.phone}</strong> within 24 hours if you need help.
          </>
        ) : null}
      </span>
    </div>
  );
}
